<template>
  <section class="activities-today"
    :class="$firefox ? `activities-today--${this.slugify(name)}` : `activities-today--${this.slugify(name)} scrollmagic__today-fade-in-up`"
  >
    <div class="activities-today__container">
      <header class="activities-today__header">
        <h2 class="activities-today__title">{{ name }}</h2>

        <p class="activities-today__difference"
          v-if="difference"
          :class="{ 'activities-today__difference--positive': difference > 0, 'activities-today__difference--negative': difference < 0 }"
        >{{ direction }}
          <i-count-up
            :start="0"
            :end="difference"
            :decimals="2"
            :duration="0.5"
            :options="countUpPercent"
          ></i-count-up>
        </p>
      </header>

      <div class="activities-today-columns activities-today-columns--single">
        <p class="activities-today__result activities-today__result--28">
          <i-count-up
            :start="0"
            :end="amount"
            :decimals="type == 'money' || type == 'percent' ? 2 : 0"
            :duration="0.5"
            :options="findOption(type)"
          ></i-count-up>
          <i class="activities-today__indicator activities-today__indicator--positive" v-if="difference && difference > 0"></i>
          <i class="activities-today__indicator activities-today__indicator--negative" v-if="difference && difference < 0"></i>
        </p>

        <small class="activities-today__info">Yesterday:
          <i-count-up
            :start="0"
            :end="previousAmount"
            :decimals="type == 'money' ? 2 : 0"
            :duration="0.5"
            :options="findOption(type)"
          ></i-count-up>
          at {{ dateFormat(now, 'hh:mm a') }}
        </small>

        <simple-bar-chart
          v-if="chartData.datasets.length > 0"
          :chartData="chartData"
          :width="205"
          :height="92"
          :options="{responsive: false, maintainAspectRatio: false}"
        ></simple-bar-chart>
      </div>
    </div>
  </section>
</template>

<script>
  import SimpleBarChart from '@/components/charts/SimpleBarChart'

  import { tile } from '@/mixins/tile.js'

  import ICountUp from 'vue-countup-v2'

  export default {
    name: 'todayTile',
    components: {
      'i-count-up': ICountUp,
      'simple-bar-chart': SimpleBarChart
    },
    props: {
      amount: {
        default: 0,
        required: true,
        type: Number
      },
      chartData: {
        default: function () {
          return {
            labels: [],
            datasets: []
          }
        },
        type: Object
      },
      name: {
        default: '',
        required: true,
        type: String
      },
      now: {
        type: Object
      },
      previousAmount: {
        default: 0,
        required: true,
        type: Number
      }
    },
    mixins: [tile]
  }
</script>


// WEBPACK FOOTER //
// src/js/components/TodayTile.vue